import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLang } from '../context/LanguageContext';

const floatingFruits = ['🍊', '🍋', '🍈', '🍑', '🍊', '🍋', '🍊', '🍋'];

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const { t, lang, toggleLang } = useLang();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || t('login_failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-citrus-pattern relative overflow-hidden"
         style={{ background: 'linear-gradient(135deg, #fff7ed 0%, #fef9c3 50%, #f0fdf4 100%)' }}>
      {floatingFruits.map((fruit, i) => (
        <div key={i} className="absolute text-4xl opacity-20 select-none pointer-events-none"
          style={{ left: `${10 + (i * 12) % 80}%`, top: `${5 + (i * 17) % 80}%`,
            animation: `bounce ${2 + (i % 3)}s ease-in-out infinite`, animationDelay: `${i * 0.3}s` }}>
          {fruit}
        </div>
      ))}

      {/* Language toggle */}
      <button onClick={toggleLang}
        className="absolute top-4 right-4 px-4 py-2 rounded-full text-sm font-bold bg-white bg-opacity-80 shadow-md active:bg-gray-100 transition-all touch-active z-10">
        {lang === 'en' ? '🇹🇷 Türkçe' : '🇬🇧 English'}
      </button>

      <div className="w-full max-w-md px-4 fade-in">
        <div className="bg-white rounded-3xl shadow-2xl p-8 border border-orange-100">
          <div className="text-center mb-8">
            <img src="/aksun-logo.png" alt="Aksun" className="h-16 w-auto mx-auto mb-4" />
            <p className="text-gray-500 mt-1 text-sm font-medium">{t('app_subtitle')}</p>
          </div>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-xl text-sm font-medium fade-in">{error}</div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-1.5">{t('username')}</label>
              <input type="text" value={username} onChange={(e) => setUsername(e.target.value)}
                className="w-full px-4 py-4 border-2 border-orange-200 rounded-xl focus:outline-none focus:border-orange-400 focus:ring-2 focus:ring-orange-100 transition-all text-gray-700"
                placeholder={t('enter_username')} required />
            </div>
            <div>
              <label className="block text-sm font-bold text-gray-700 mb-1.5">{t('password')}</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-4 border-2 border-orange-200 rounded-xl focus:outline-none focus:border-orange-400 focus:ring-2 focus:ring-orange-100 transition-all text-gray-700"
                placeholder={t('enter_password')} required />
            </div>
            <button type="submit" disabled={loading}
              className="w-full py-4 px-4 rounded-xl text-white font-bold text-lg shadow-lg active:shadow-md active:scale-95 transition-all duration-200 disabled:opacity-50 touch-active"
              style={{ background: 'linear-gradient(135deg, #f97316, #f59e0b)' }}>
              {loading ? (
                <span className="flex items-center justify-center">
                  <span className="fruit-spin inline-block mr-2">🍊</span> {t('logging_in')}
                </span>
              ) : (
                `${t('login')} 🍊`
              )}
            </button>
          </form>

          <div className="mt-6 text-center text-xs text-gray-400">Aksun Quality Control System v1.3</div>
        </div>
      </div>
    </div>
  );
}
